import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

function Tabla11Obtener(props) {
  const cookie = new Cookies();
  const [datos, setDatos] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const itemsPorPagina = 5;

  const obtenerDatos = () => {
    axios
      .get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerTablaNumeral/" +
          props.idSolicitud,
      )
      .then((response) => {
        setDatos(response.data);
        setPaginaActual(1);
      })
      .catch((error) => {
        console.error("Error al obtener los datos", error);
      });
  };

  useEffect(() => {
    if (props.idSolicitud) {
      obtenerDatos();
    }
  }, [props.idSolicitud]);

  const eliminarInformacion = () => {
    Swal.fire({
      title: "¿Eliminar información?",
      text: "Se eliminarán todas las calificaciones asociadas a esta solicitud. Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Eliminando...",
          text: "Por favor espere",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        axios
          .delete(
            "https://suadesarrollo.azurewebsites.net/api/EliminarCalificaciones/" +
              props.idSolicitud,
          )
          .then((response) => {
            Swal.fire({
              title: "Eliminado",
              text: "La información fue eliminada correctamente.",
              icon: "success",
              confirmButtonText: "Aceptar",
            });

            setDatos([]);
            setPaginaActual(1);
          })
          .catch((error) => {
            console.error("Error al eliminar la información", error);

            Swal.fire({
              title: "Error",
              text:
                error.response?.data?.message ||
                "No fue posible eliminar la información.",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          });
      }
    });
  };

  const totalPaginas = Math.ceil(datos.length / itemsPorPagina);
  const indiceInicio = (paginaActual - 1) * itemsPorPagina;
  const indiceFin = indiceInicio + itemsPorPagina;
  const datosPagina = datos.slice(indiceInicio, indiceFin);

  const irPaginaAnterior = () => {
    if (paginaActual > 1) {
      setPaginaActual(paginaActual - 1);
    }
  };

  const irPaginaSiguiente = () => {
    if (paginaActual < totalPaginas) {
      setPaginaActual(paginaActual + 1);
    }
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-body">
              <div className="d-flex justify-content-end mb-3">
                {cookie.get("tipo_Usaurio") != 2 ? (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={eliminarInformacion}
                    disabled={datos.length === 0}
                  >
                    Eliminar información
                  </button>
                ) : (
                  <p></p>
                )}
              </div>

              <div className="table-responsive">
                <table
                  className="table table-bordered text-justify"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th className="text-justify">Grupo</th>
                      <th>Puntaje</th>
                      <th>Calificación</th>
                    </tr>
                  </thead>

                  <tbody>
                    {datosPagina.length > 0 ? (
                      datosPagina.map((item) => (
                        <tr key={item.id}>
                          <td>{item.grupo}</td>
                          <td>{item.puntaje}</td>
                          <td>{item.calificacion}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No hay información para mostrar
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {datos.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={irPaginaAnterior}
                      disabled={paginaActual === 1}
                    >
                      Anterior
                    </button>

                    <span>
                      Página {paginaActual} de {totalPaginas}
                    </span>

                    <button
                      className="btn btn-primary"
                      onClick={irPaginaSiguiente}
                      disabled={paginaActual === totalPaginas}
                    >
                      Siguiente
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tabla11Obtener;
